import React from "react";

function StickyCTA({ onBook, phone }) {
  return (
    <div
      className="position-fixed bottom-0 start-0 w-100 bg-white shadow p-3 d-lg-none"
      style={{ zIndex: 1000 }}
    >
      <div className="d-flex gap-2">
        <button className="btn navyblue-bg w-50" onClick={onBook}>
          Book Now
        </button>

        <a
          href={`https://wa.me/${phone}?text=Hello, I am interested in this package`}
          className="btn btn-success w-50"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </a>
      </div>
    </div>
  );
}

export default StickyCTA;
